import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Header } from "./header";
import { Footer } from "./footer";
import { Index } from "./index";
import styled from "styled-components";
import { Greetings } from "./AboutUs/greetings";
import { BPlayground } from "./Business/b-playground";
import { Cogame } from "./Business/cogame";
import { Inform } from "./Community/inform";
import { Faq } from "./Support/faq";
import { History } from "./AboutUs/history";
import { Vision } from "./AboutUs/vision";
import { Map } from "./AboutUs/map";
import { News } from "./Community/news";
import { Hiring } from "./Community/hiring";
import { Inquiry } from "./Support/inquiry";
import { BoardView } from "./Admin/boardView";
import { InquiryWrite } from "./Support/inquiryWrite";
import { Popup } from "./Admin/popup";
import { AdminWrite } from "./Admin/adminWrite";
import { AdminLogin } from "./Admin/adminLogin";
import { RequireAdmin } from "./Admin/requireAdmin";

const Container = styled.div`
  width: 100%;
  height: 100%;
`;
const Section = styled.section`
  margin-top: clamp(60px, 10vw, 120px);
`;

export function Main() {
  return (
    <>
      <BrowserRouter basename="/">
        <Container>
          <div>
            <Header />
          </div>
          <Section>
            <Routes>
              <Route path="/" element={<Index />} />
              {/* 회사소개 항목 */}
              <Route path="/aboutUs/greetings" element={<Greetings />} />
              <Route path="/aboutUs/vision" element={<Vision />} />
              <Route path="/aboutUs/history" element={<History />} />
              <Route path="/aboutUs/map" element={<Map />} />
              {/* 사업소개 항목 */}
              <Route path="/business/b-playground" element={<BPlayground />} />
              <Route path="/business/cogame" element={<Cogame />} />
              {/* 커뮤니티 항목 */}
              <Route path="/community/inform" element={<Inform />} />
              <Route path="/community/inform/:id" element={<BoardView />} />
              <Route path="/community/news" element={<News />} />
              <Route path="/community/news/:id" element={<BoardView />}></Route>
              <Route path="/community/hiring" element={<Hiring />} />
              <Route path="/community/hiring/:id" element={<BoardView />} />
              {/* 고객지원 항목 */}
              <Route path="/support/faq" element={<Faq />} />
              <Route path="/support/inquiry" element={<Inquiry />} />
              {/* 문의글 작성 */}
              <Route
                path="/support/inquiry/inquiryWrite"
                element={<InquiryWrite />}
              />
              <Route
                path="/support/inquiry/:id"
                element={<BoardView />}
              ></Route>
              {/* 게시글 작성/수정/확인 항목 */}
              <Route path="/boardWrite" element={<InquiryWrite />} />
              <Route path="/boardModify/:id" element={<InquiryWrite />} />
              {/* 관리자 로그인 */}
              <Route path="/admin/login" element={<AdminLogin />} />
              {/* 관리자 전용 게시물 작성 */}
              <Route
                path="/adminWrite"
                element={
                  <RequireAdmin>
                    <AdminWrite />
                  </RequireAdmin>
                }
              />
              <Route
                path="/boardModifyAdmin/:id"
                element={
                  <RequireAdmin>
                    <AdminWrite />
                  </RequireAdmin>
                }
              />
              {/* 팝업 관리 항목 */}
              <Route
                path="/popup"
                element={
                  <RequireAdmin>
                    <Popup />
                  </RequireAdmin>
                }
              />
              <Route path="/popup/:id" element={<BoardView />} />
            </Routes>
            {/* <Index /> */}
          </Section>
          <div className="footer_wrapper">
            <Footer />
          </div>
        </Container>
      </BrowserRouter>
    </>
  );
}
